import { createFileRoute } from '@tanstack/react-router'
import { requireAuthBeforeLoad } from '@/features/auth/guards'
import { BrandingCanvas } from '@/features/app-shell/canvases/branding-canvas'

export const Route = createFileRoute('/app/branding')({
  beforeLoad: ({ location }) => requireAuthBeforeLoad({ location }),
  component: AppBrandingPage,
})

function AppBrandingPage() {
  return <BrandingCanvas />
}
